import { render } from "./system-configuration.vue?vue&type=template&id=ae980dc0&ts=true"
import script from "./system-configuration.vue?vue&type=script&lang=ts"
export * from "./system-configuration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__